import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '@components/button';
import { RouterModule } from '@angular/router';
import { CartDetailStripComponent } from './cart-detail-strip.component';
import { DirectivesModule } from '@directives/directives.module';

@NgModule({
    imports: [CommonModule, RouterModule, ButtonModule, DirectivesModule],
  declarations: [CartDetailStripComponent],
  exports: [CartDetailStripComponent],
})
export class CartDetailStripModule {}
